import { OnInit, inject } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PlacementTestsService } from './study-guide-placement-test/components/services/placement-tests.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterModule]
})
export class AppComponent implements OnInit {

  static readonly MOBILE_CLASS = 'mobile';

  readonly #translateService = inject(TranslateService);
  readonly #route = inject(ActivatedRoute);
  readonly #deviceService = inject(DeviceDetectorService);
  readonly #placementTestsService = inject(PlacementTestsService);

  constructor() {
    // this language will be used as a fallback when a translation isn't found in the current language
    this.#translateService.setDefaultLang('de');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.#translateService.use('de');
  }

  ngOnInit(): void {
    // callback for query parameter
    this.#route.queryParams.subscribe(params => {
      if (params['lang']) {
        this.#translateService.use(params['lang']);
      }
      if (params['token']) {
        this.#placementTestsService.token = params['token'];
      }
    });

    if (this.#deviceService.isMobile()) {
      document.body.classList.add(AppComponent.MOBILE_CLASS);
    }
  }
}
